import { createSlice } from "@reduxjs/toolkit";

import i18n from "../i18n";

const MOBILE_BREAKPOINT = 768;
let nextToastId = 1;

export const uiSlice = createSlice({
  name: "ui",
  initialState: {
    globalError: null,
    toasts: [],
    loading: false,
    pageTitle: "",
    relocationCasesFitler: null,
    taskFilter: null,
    taskProgressFilter: null,
    showSessionTooBigModal: false,
    hideFullTaskList: false,
    isMobileView: window.innerWidth < MOBILE_BREAKPOINT,
    showMobileMenu: false,
    showWaitingListModal: false,
    showFormChangedWarning: false,
  },
  reducers: {
    addToastMessage: (state, { payload }) => {
      state.toasts = [...state.toasts, payload];
    },

    removeToastMessage: (state, { payload }) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== payload);
    },

    setGlobalError: (state, { payload }) => {
      state.globalError = payload ? i18n.t(payload) : null;
    },

    setLoading: (state, { payload }) => {
      state.loading = payload;
    },

    setTaskFilter: (state, { payload }) => {
      state.taskFilter = payload;
    },

    setTaskProgressFilter: (state, { payload }) => {
      state.taskProgressFilter = payload;
    },

    setRelocationCasesFilter: (state, { payload }) => {
      state.relocationCasesFitler = payload;
    },

    setShowSessionTooBigModal: (state, { payload }) => {
      state.showSessionTooBigModal = payload;
    },

    setHideFullTaskList: (state, { payload }) => {
      state.hideFullTaskList = payload;
    },

    setIsMobileView: (state, { payload }) => {
      state.isMobileView = payload;
    },

    setShowMobileMenu: (state, { payload }) => {
      state.showMobileMenu = payload;
    },

    setShowWaitingListModal: (state, { payload }) => {
      state.showWaitingListModal = payload;
    },

    setShowFormChangedWarning: (state, { payload }) => {
      state.showFormChangedWarning = payload;
    },

    toggleMobileMenu: (state) => {
      state.showMobileMenu = !state.showMobileMenu;
    },
  },
});

export function createToastMessage(dispatch, payload) {
  const message = {
    ...payload,
    id: nextToastId++,
    time: payload.time || 3000,
  };
  dispatch(addToastMessage(message));
  setTimeout(() => {
    dispatch(removeToastMessage(message.id));
  }, message.time);
}

export const {
  addToastMessage,
  removeToastMessage,
  setGlobalError,
  setHideFullTaskList,
  setIsMobileView,
  setLoading,
  setRelocationCasesFilter,
  setShowMobileMenu,
  setShowSessionTooBigModal,
  setShowWaitingListModal,
  setTaskFilter,
  setTaskProgressFilter,
  toggleMobileMenu,
} = uiSlice.actions;

export default uiSlice.reducer;
